const app = {
  scan_dialog_title: 'Result',
  scan_result_total: 'Total',
  scan_result_success: 'Finished Chips',
  scan_result_fail: 'Failed Chips',
  nfc_msg:
    'Please place the NFC device close to the chip and hold still to read it',
  rfid_msg: 'Please turn on UHF RFID to read the chip',
  infrar_msg: 'Please press the button on code scanner to read the QR code',
  qr_msg: 'Please scan the QR code to read the data',
  barcode_msg: 'Please scan the barcode to read the data',
  qrcode_single_msg: 'Please scan the QR code to read the data',
  barcode_single_msg: 'Please scan the barcode to read the data',
  qrcode_multi_msg: 'Please scan the QR code to read the data',
  barcode_multi_msg: 'Please scan the barcode to read the data',
  btn_save: 'Save',
  btn_save_draft: 'Save draft',
  btn_submit: 'Submit',
  btn_clear: 'Cancel',
  btn_confirm: 'Confirm',
  btn_add: 'Add more',
  no_data: 'No data',
  nfc: 'NFC',
  rfid: 'UHF RFID',
  qr: 'Camera',
  infrar: 'Barcode scanner',
  single: 'one VID',
  multi: 'multiple VID',
  customid_single: 'one custom ID',
  customid_multi: 'multiple custom ID',
  customid_range: 'custom ID range',
  id_type_custom: 'Custom ID',
  id_type_vid: 'VID',
  qrcode_single: 'one qrcode',
  qrcode_multi: 'multiple qrcode',
  barcode_single: 'one barcode',
  barcode_multi: 'multiple barcode',
  choose_dialog_title: 'Scanning Method',
  del_all: 'Erase all',
  scan_limit: 'Scanned VIDs have reached the maximum value',
  scan_content_overflow: 'Scanned content have reached the maximum value',
  upload_pdf: 'Click to Upload PDF',
  upload_img: 'Click to Upload Image',
  upload_video: 'Click to Upload Video',
  upload_audio: 'Click to Upload Audio',
  required: 'required',
  max_valid: 'length limit is {max}',
  update: 'Update',
  switch_true: 'True',
  switch_false: 'False',
  add_ref_data_button: 'Select data',
  components_render_placeholder_filter: "Filter",
  required_error: "Required",

  project_internal: 'My DCP',
  project_external: 'External DCP',
  dcp_search_placeholder: 'Search or quick search by company name',
  dcp_data_name: 'Name',
  dcp_bu: 'Company',
  dcp_project: 'Project',
  dcp_type: 'DCP type',
  dcp_update_date: 'Date',
  dcp_advanced_search: 'Advanced search',
  dcp_search_cancel: 'Cancel',
  dcp_start_time: 'Start date',
  dcp_end_time: 'End date',
  dcp_data_info: 'Data information',
  dcp_data_update: 'Data Updated',
  dcp_cancel: 'Cancel',
  dcp_confirm: 'Confirm',
  dcp_options_placeholder: 'Please select',
  dcp_filter_name: 'Name',
  dcu_close: 'Close',
  dcu_confirm: 'Confirm',
  viderror: {
    1003: "Invalid request params exception",
    1300300046: "Vids error",
    1300301046: "VidList is empty",
    1300300040: "Vids error",
    1300300029: "Insufficient balance. Please purchase TCC or contact our operations staff.",
    1300301045: "Check fail",
    1300300042: "Big vid has been used",
    1300440000: "Verification data is not existed",
    1300440004: "Verification data is not existed",
    1300440001: "Verification data is processing",
    1300440002: "Data has been verified",
    1300440003: "Verification data is existed",
    1300440005: "Verification report name is exists,please rename it",
    1300440007: "The data is invalid",
    1300000000: "Failed to submit. Your content contains illegal information (e.g. pornography, gambling or drugs)",
    1300300037: "Current group has been bound with multiple layers of data. You may create a new group.",
    default: "Check fail"
  },
  vid_startingcode: "starting code:",
  vid_endingcode: "ending code:",
  scaned_id_list: "ID list",
  delete_execption_id: "remove execption ID",
  delete_all_id: "remove all ID"
}
export default app;
